import * as yup from 'yup';
import { DataTableHtmlFormatter } from '../../../Component/Model/helpers';

const monitoringMaxLength: number = 600;

export const monitoringAndEvaluationSchema = yup.object({
	detail: yup
		.string()
		.nullable()
		.test('detailLengthTest', `Detail is too long! (Max length is 600 characters)`, (value) => {
			if (!value) {
				return true;
			}
			return DataTableHtmlFormatter(value, '').length <= monitoringMaxLength;
		}),
});
